import useSWR from "swr";

import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const fetcher = (url: string) => fetch(url, { credentials: "include" }).then((res) => res.json());

export function ViralCandidatesPanel() {
  const { data, isLoading } = useSWR("/marketing/analytics/viral-candidates", fetcher);
  const candidates = data?.candidates ?? [];
  const recommendations = data?.recommendations ?? [];

  return (
    <Card className="space-y-3 border-border/70 bg-background/40 p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-semibold text-foreground">Viral Detector</p>
          <p className="text-xs text-muted-foreground">High-momentum clips to boost now.</p>
        </div>
        <p className="text-[11px] uppercase text-muted-foreground">{data?.generated_at ?? ""}</p>
      </div>
      {isLoading ? (
        <p className="text-xs text-muted-foreground">Scanning performance…</p>
      ) : (
        <div className="space-y-2">
          {candidates.map((candidate: any) => (
            <div key={candidate.id} className="rounded-xl border border-border/70 bg-background/40 p-3 text-sm text-foreground/80">
              <div className="flex items-center justify-between">
                <p className="text-foreground">{candidate.title}</p>
                <Badge className="bg-success/20 text-success">{candidate.platform}</Badge>
              </div>
              <p className="text-xs text-muted-foreground">Score {candidate.viral_score} · shares {candidate.share_view_ratio}</p>
              <p className="text-xs text-muted-foreground">Audio: {candidate.audio_match}</p>
            </div>
          ))}
          {!candidates.length ? <p className="text-xs text-muted-foreground">No viral candidates yet.</p> : null}
        </div>
      )}
      {recommendations.length ? (
        <div>
          <p className="text-xs uppercase tracking-wide text-muted-foreground">Recommendations</p>
          <ul className="mt-1 list-disc pl-4 text-xs text-muted-foreground">
            {recommendations.map((rec: string) => (
              <li key={rec}>{rec}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </Card>
  );
}
